import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InjectorHelper } from '../../../helpers/injector.helper';
import { WorkflowType } from '../../../models/enums/workflowtype.enum';
import { WorkflowModuleExecuter, WorkflowStatus } from '../../../models/workflow/workflow.model';
import { DBUserService } from '../../../services/dbuser.service';
import { WorkflowExitInfo, WorkflowModuleSettingsHelper, WorkflowRegistry } from '../../../services/workflow.service';
import { FormulaWorkflowDialogContent } from '../../workflow.dialog';
import { WorkflowFormulaCalculator } from '../definevalue/define.value.settings';
import { ClassTransformerHelper } from '../../../helpers/class.transformer.helper';

@Component({
    selector: 'update-password-settings',
    templateUrl: './update.password.settings.html'
})
export class UpdatePasswordSettings extends FormulaWorkflowDialogContent {
    static ModuleID = 'updatePWModule';
    Data = new UpdatePasswordSettingsData();

    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = UpdatePasswordSettings.ModuleID;
        reg.Caption = '@@UpdatePassword'
        reg.GroupID = 'wfActions';
        reg.Index = 117;
        reg.SettingsControl = UpdatePasswordSettings;
        reg.SettingsTypeHelper = new UpdatePasswordSettingsDataHelper();
        reg.Executer = UpdatePasswordModuleExecuter;
        reg.WorkflowType = WorkflowType.Client;
        return reg;
    }

    initialize(data: any) {
        super.initialize(data);
        if (data) {
            this.Data = ClassTransformerHelper.CopyObject(data, UpdatePasswordSettingsData);
        }
    }

    getResult() {
        return this.Data;
    }
}

export class UpdatePasswordSettingsData {
    NewPassword: string;
}

export class UpdatePasswordSettingsDataHelper extends WorkflowModuleSettingsHelper {
    getExitPoints(settings: any): WorkflowExitInfo[] {
        return [new WorkflowExitInfo()];
    }
    getEmptySettingsInstance() {
        return new UpdatePasswordSettingsData();
    }
}

export class UpdatePasswordModuleExecuter extends WorkflowModuleExecuter {
    async execute(status: WorkflowStatus): Promise<number> {
        return new Promise<number>(resolve => {
            if (status.ActualSettings && status.ActualSettings.NewPassword) {
                const data = this.getDataObj();
                if (data) {
                    const calculator = new WorkflowFormulaCalculator(status);
                    data.Password = calculator.CalcFormula(status.ActualSettings.NewPassword);
                    const dbUserService = InjectorHelper.InjectorInstance.get<DBUserService>(DBUserService);
                    dbUserService.ResetUserPasswordAdvanced(data).subscribe((result: any) => {
                        if (result) {
                            if (result.Success) {
                                resolve(0);
                            } else {
                                status.ActualParameter = result.Error;
                                status.Logger.logError('Update password modul: ' + result.Error);
                                resolve(-1);
                            }
                        } else {
                            status.ActualParameter = 'Error while updating password';
                            status.Logger.logError('Update password modul: Error while updating password.');
                            resolve(-1);
                        }
                    });
                } else {
                    status.ActualParameter = 'No password reset token found';
                    status.Logger.logError('Update password modul: No password reset token found.');
                    resolve(-1);
                }
            } else {
                status.ActualParameter = 'No settings found';
                status.Logger.logError('Update password modul: No settings found.');
                resolve(-1);
            }
        });
    }

    private getDataObj() {
        const activatedRoute = InjectorHelper.InjectorInstance.get<ActivatedRoute>(ActivatedRoute);
        const queryParams = activatedRoute.snapshot.queryParams;
        const data = queryParams['resetPWData'];
        if (data) {
            const base64Encoded = data.replace(/-/g, '+').replace(/_/g, '/');
            const padding = data.length % 4 === 0 ? '' : '='.repeat(4 - (data.length % 4));
            const base64WithPadding = base64Encoded + padding;
            const retVal = atob(base64WithPadding)
                .split('')
                .map(char => String.fromCharCode(char.charCodeAt(0)))
                .join('');
            return JSON.parse(retVal);
        }
        return null;
    }
}
